import metrikaCollector, {collectYandexReachGoal} from 'components/metrika';

let installed = false;

function getHotelId() {
    const $hotelData = document.querySelector('.js-hotelData');

    if (!$hotelData?.dataset.hotel_id) {
        return 0;
    }

    return +$hotelData.dataset.hotel_id;
}

function reachSidePhonesGoal(goal) {
    if (typeof yaCounter46243086 === 'undefined') {
        return;
    }

    const hotelId = getHotelId();

    if (hotelId) {
        const params = {hotel_id: hotelId};
        yaCounter46243086.reachGoal(goal, params);
        collectYandexReachGoal(metrikaCollector, goal, {data: params});
        return;
    }

    yaCounter46243086.reachGoal(goal);
    collectYandexReachGoal(metrikaCollector, goal);
}

/**
 * Цели Метрики по кликам в сайдбаре «Забронировать по телефону» на карточке объекта.
 */
export function initSidePhonesMetrika() {
    if (installed) {
        return;
    }

    installed = true;

    document.addEventListener('mousedown', (e) => {
        if (e.target.closest('.SidePhones .js-sidePhonesMaxLink')) {
            reachSidePhonesGoal('max_click_object');
            return;
        }

        if (e.target.closest('.SidePhones a.SidePhones__phone[href^="tel:"]')) {
            reachSidePhonesGoal('phone_click_object');
        }
    });
}
